import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TicketApplicationForm.html?raw';
import Edit from '../../../moreCore/UI/Edit/Edit';
import '../../../moreCore/UI/Edit/Edit';
import NumberInput from '../../../moreCore/UI/NumberInput/NumberInput';
import '../../../moreCore/UI/NumberInput/NumberInput';
import HintBox from '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import '../../../moreCore/UI/EntityBased/HintBox/HintBox';
import { TicketTypes } from "../TicketTypes";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';

class TicketApplicationForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private txtTitle: HTMLElement;
    private txtStatus: HTMLElement;
    private txtContingentText: HTMLElement;

    private sectionAddress2: HTMLElement;

    private inputAddressRequestedFor: MdsLax<InstanceType<typeof HintBox>>;
    private inputAddressRequestedFor_Contact: MdsLax<InstanceType<typeof HintBox>>;
    private inputAddressRequestedBy: MdsLax<InstanceType<typeof HintBox>>;
    private inputNote: MdsLax<InstanceType<typeof Edit>>;
    private inputTicketCount: MdsLax<InstanceType<typeof NumberInput>>;
    private inputTicketsApproved: MdsLax<InstanceType<typeof NumberInput>>;
    
    private entityId: string;
    private contingentEntity: TicketTypes.TicketContingentEntity;

    private entity: TicketTypes.TicketEntity;

    private dlg: MdsLax<InstanceType<typeof GenericDialog>>;

    private readonly: boolean = false;

    openInDlg(): void {
        if (!this.contingentEntity && this.entity?.ref_vt_pos_ev_calc_ticket_contingent) {
            this.setContingent(this.entity.ref_vt_pos_ev_calc_ticket_contingent as any);
        }

        if (!this.contingentEntity) {
            alert("no ticket contingent!")
            return;
        }

        let dlg = new GenericDialog();
        this.dlg = dlg;

        let entity = this.entity;
        let contingent = this.contingentEntity;


        dlg.show(this,
            this.contingentEntity?.ref_ev_planning.gDisp_1,
            null,
            null,
            entity ? "saveclose" : "submitcancel",
            lang.hitch(this, this.dlgCallback));

        this.handleDlgButtons();

        dlg.disableButton("save");
        dlg.disableButton("submit");

        if (!entity) this.serializeFormData();

        dlg.keepOpen = true;
        dlg.closeOnEnter = false;
        dlg.closeOnEscape = false;
    }

    private handleDlgButtons(): void {
        if (!this.dlg) return;
        let entity = this.entity;
        let dlg = this.dlg;
        let contingent = this.contingentEntity;

        if (entity?.ref_address_3?.ID == this.getCurrentEmployeeId()) {
            dlg.addButton("cancelRequest",
                this.translate("TicketPool_Btn_CancelRequest"),
                lang.hitch(this, this._onClick_CancelRequest),
                null,
                "w3-red",
                "fas fa-ban",
                false,
                "left first",
                false);

            let now = new Date();
            if (contingent.ref_ev_planning.date_start.valueOf() > now.valueOf() &&
                entity.ref_ev_calc_ticket_02_status?.is_locked_applied === false &&
                entity.ref_ev_calc_ticket_02_status?.is_locked_approved === false) {
                dlg.enableButton("cancelRequest");
            }
        } else {
            dlg.removeButton("save");
        }

    }

    private dlgCallback(result) {
        if (result >= 1) {
            this.saveTicket();
        } else {
            this.dlg.close(-1, true);
        }
    }

    private _onTicketRequestSaved() {
        this.emit("saved");

        if (this.dlg) this.dlg.close(1, true);
    }

    private _onTicketRequestCancelled() {
        this.emit("cancelled");

    }

    private _onClick_CancelRequest() {
        if (confirm(this.translate("TicketPool_CancelRequest_ConfirmationMessage"))) {
            this.cancelTicketRequest();
        }
    }

    setTitle(title: string, contingenttext?: string) {

        this.txtTitle.innerHTML = title;

        if (contingenttext) {
            this.hideNode(this.txtContingentText, false);
            this.txtContingentText.innerHTML = contingenttext;
        }

    }
    setContingent(entity: TicketTypes.TicketContingentEntity) {
        if (typeof (entity?.ref_ev_planning?.date_start) == "string") {
            try {
                entity.ref_ev_planning.date_start = new Date(entity.ref_ev_planning.date_start);
            } catch (ex) {

            }
        }
        this.contingentEntity = entity;
        this.setTitle(entity.ref_ev_planning.gDisp_1,
            entity.ticket_defaulttext);
    }

    setReadonly(bReadonly: boolean = true) {
        this.disableNode(this.domNode, bReadonly);
        this.readonly = bReadonly;
    }

    setTicket(entity: TicketTypes.TicketEntity) {
        this.entityId = entity.ID;
        this.entity = entity;
        
        if (entity.ref_vt_pos_ev_calc_ticket_contingent && !this.contingentEntity) this.setContingent(entity.ref_vt_pos_ev_calc_ticket_contingent as any);

        let now = new Date();
        if (this.contingentEntity?.ref_ev_planning.date_start?.valueOf() < now.valueOf() ||
            this.entity.ref_address_3.ID != this.getCurrentEmployeeId() ||
            this.entity?.ref_ev_calc_ticket_02_status?.is_locked_applied == true ) {
            this.setReadonly(true);
        }
        this.inputTicketCount.setReadonly(entity.ref_ev_calc_ticket_02_status?.is_locked_applied == true);

        this.inputTicketCount.setValue(entity.tickets_applied, true);

        this.inputAddressRequestedBy.setReadonly(true)
        this.inputAddressRequestedBy.setValue(entity.ref_address_3, true);
        this.inputAddressRequestedFor.setValue(entity.ref_address_1 ? entity.ref_address_1 : entity.c_address_1, true);

        this.handleForAddressContact();

        if (entity.ref_address_2) this.inputAddressRequestedFor_Contact.setValue(entity.ref_address_2, true);
        else if (entity.c_address_2) this.inputAddressRequestedFor_Contact.setValue(entity.c_address_2, true);

        this.inputTicketsApproved.setValue(entity.tickets_approved, true);
        this.hideNode(this.inputTicketsApproved, false);

        if (entity.ref_ev_calc_ticket_02_status) {
            this.txtStatus.innerHTML = entity.ref_ev_calc_ticket_02_status?.description;
            if (entity.ref_ev_calc_ticket_02_status?.coloration) {
                this.UiModder.domStyle.set(this.txtStatus, "backgroundColor", entity.ref_ev_calc_ticket_02_status.coloration.BackColor.Hex);
                this.UiModder.domStyle.set(this.txtStatus, "color", entity.ref_ev_calc_ticket_02_status.coloration.TextColor.Hex);
            }
            this.hideNode(this.txtStatus, false);
        } else {
            this.hideNode(this.txtStatus);
        }

        this.inputNote.setValue(entity.note, true);

        this.handleDlgButtons();
    }

    cancelTicketRequest(): boolean {
        if (!this.entity) return false;

        if (this.dlg) this.dlg.disableButton("cancelRequest");

        let data = {
            ticketID: this.entityId
        };

        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_TicketPool__CancelTicketApplication",
            data,
            lang.hitch(this, this._onCancelTicketRequestResponse),
            lang.hitch(this, this._onSaveTicketRequestError),
            true
        );

        return true;
    }

    private _onCancelTicketRequestResponse(response: TicketTypes.TicketEntity) {
        this.StandbyStop();

        this.disableNode(this.domNode);
        this._onTicketRequestCancelled();

        this._onSaveTicketRequestResponse(response);

    }


    saveTicket() {
        let validation = false;
        let validAddress = this.inputAddressRequestedBy.validateInput();

        validation = validAddress && this.inputTicketCount.validateInput() && this.inputAddressRequestedFor.validateInput();

        if (validation == true) {
            this._sendTicketData();
        } else {
            this.inputAddressRequestedBy.validateInput();
            this.inputTicketCount.validateInput();
        }
    }

    private _sendTicketData() {
        let data = this.serializeFormData();

        if (!data) return;

        if (this.dlg) this.dlg.disableButton("save");

        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_TicketPool__SaveTicketApplication",
            data,
            lang.hitch(this, this._onSaveTicketRequestResponse),
            lang.hitch(this, this._onSaveTicketRequestError),
            false // sync
        );
    }

    private _onSaveTicketRequestResponse(response: TicketTypes.TicketEntity) {
        this.setTicket(response);
        this.StandbyStop();
        this._onTicketRequestSaved();
    }

    private _onSaveTicketRequestError(err: more.requestErrorMessage) {
        this.StandbyStop();
        alert(err.Message);
    }

    private serializeFormData(): TicketTypes.TicketRequestData {
        let data: TicketTypes.TicketRequestData = {
            contingentID: this.contingentEntity?.ID,
            ticketID: this.entityId,
            addressRequestedFor: this.inputAddressRequestedFor.getValue("value"),
            addressRequestedForContact: this.inputAddressRequestedFor_Contact.getValue("value"),
            addressRequestedBy: this.inputAddressRequestedBy.getValue("value"),
            ticketCount: this.inputTicketCount.getValue(),
            note: this.inputNote.getValue()
        };

        if (data.contingentID &&
            data.addressRequestedFor &&
            data.addressRequestedBy &&
            data.ticketCount > 0) {

            let now = new Date();

            // nur Änderungen erlauben wenns in der Zukunft liegt!
            if (this.contingentEntity && this.contingentEntity.ref_ev_planning.date_start.valueOf() > now.valueOf()) {
                if (this.dlg) {
                    this.dlg.enableButton("save");
                    this.dlg.enableButton("submit");
                }
                this.emit("dirty");
            }

            return data;
        } else {
            if (this.dlg) {

                this.dlg.disableButton("save");
                this.dlg.disableButton("submit");
            }
            this.emit("dirty", false);
        }

        return null;

    }
    

    private _onChange_TicketCount() {
        this.serializeFormData();
    }

    private _onChange_InputRequestedFor() {
        let data = this.serializeFormData();

        this.handleForAddressContact();
    }
    private handleForAddressContact() {
                let data = this.serializeFormData();

        let forAddress = this.inputAddressRequestedFor.getValue("entity") as AddressFinderEntity;

        if (forAddress && forAddress.Classname != "organisations_external" ||
            !data?.addressRequestedFor) {
            this.hideNode(this.sectionAddress2);
            this.inputAddressRequestedFor_Contact.setValue(null);
            this.inputAddressRequestedFor_Contact.removeRequestParams();
        } else {
            this.hideNode(this.sectionAddress2, false);
            this.inputAddressRequestedFor_Contact.addRequestProperty("address1", forAddress ? forAddress.ID : data.addressRequestedFor);
        }

    }
    private _onChange_InputRequestedForContact() {
        this.serializeFormData();
    }

    private _onChange_InputRequestedBy() {
        this.serializeFormData();

    }

    private _onChange_Note() {
        this.serializeFormData();
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.inputAddressRequestedBy.setValue({
            ID: window.sessionInfo.sessionData.CurrentEmployeeId,
            gDisp_1: window.sessionInfo.sessionData.UserDisplayName
        });
        this.inputNote.setIsMultiline(true);
        this.inputAddressRequestedFor.setValidationEnabled(true);

        this.inputAddressRequestedFor.setValidationEnabled(true);
        this.inputAddressRequestedFor.isValid = false;
        this.inputAddressRequestedFor.isMandatory = true;
        this.inputAddressRequestedFor.enablePlainTextValue = true;
        //this.inputAddressRequestedFor.enableSelectEntityDialog(true);

        this.inputTicketCount.setValidationEnabled(true);
        this.inputTicketCount.setMinRange(1);
        this.inputTicketCount.setValue(1, true);
        this.inputTicketCount.isMandatory = true;

        //this.inputAddressRequestedBy.setReadonly(true);
        this.inputAddressRequestedBy.resetOnEdit = true;
        this.inputAddressRequestedBy.enablePlainTextValue = false;

    }
    startup(): void {
        super.startup.apply(this, arguments as any);

        if (!this.entity) {
            this.inputAddressRequestedFor.setValue({
                ID: window.sessionInfo.sessionData.CurrentEmployeeId,
                gDisp_1: window.sessionInfo.sessionData.UserDisplayName
            });

        }
    }
}

export default mdsWidget(TicketApplicationForm);